<script setup>
import { onMounted, ref } from 'vue';
import ChartCard from './ChartCard.vue'

const props = defineProps({
  child: {
    type: Object,
    required: true
  },
  report: {
    type: Object,
    required: true
  }
})

const isLoading = ref(true)
onMounted(async()=>{
  isLoading.value = false
  // console.log(props.report)
})
</script>

<template>
  <div class="card">
    <CardHeader :title="report.report.attributes.package_name"/>
    <div class="card-body">
      <div class="row">
        <template v-if="report.intervention_traits.length == 0">
          <EmptyCard text="No intervention for this package" />
        </template>
        <template v-else>
          <div class="w-50" v-for="intervention_trait in report.intervention_traits">
            <ChartCard :trait="intervention_trait" :child="child"/>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>